import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Header from './components/Header'
import Footer from "./components/Footer";
import Loading from "./components/Loading";

const Home = () => {
    const [selectedTicketTypeId, setSelectedTicketTypeId] = useState("");
    const [ticketTypeIdSommerfest1, setTicketTypeIdSommerfest1] = useState(0);
    const [ticketTypeIdSommerfest2, setTicketTypeIdSommerfest2] = useState(0);
    const [loading, setLoading] = useState(false);
    const [resources, setResources] = useState({});

    const navigate = useNavigate();

    useEffect(() => {
        requestResources();
        requestFormSettings();
    }, []);

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            setTicketTypeIdSommerfest1(res.data.sommerfest1TicketTypeId);
            setTicketTypeIdSommerfest2(res.data.sommerfest2TicketTypeId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/de`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const onEventSelect = (e) => {
        setSelectedTicketTypeId(e.target.value);
    };

    const onSubmit = () => {
        if (!selectedTicketTypeId) {
            alert("Bitte w�hlen Sie eine Veranstaltung aus.");
            return;
        }

        // Navigate to shipping page with selected ticket type ID
        navigate(`/de/shipping/${selectedTicketTypeId}`);
    };

    return (
        <div>
            <Header resources={resources} />
            {loading ? (
                <Loading
                    alignment="center"
                    color="#d3d3d3"
                    bgColor="#fff"
                    top="50%"
                />
            ) : (
                <>
                    <div className="container page-container">

                        <div className="mt-4 page-container-smaller">

                            <div className="mt-4 mb-5">
                                <p dangerouslySetInnerHTML={{ __html: resources?.HomeTitleDescription }}></p>
                            </div>

                            <div className="mb-4">
                                <p className="fs-5 fw-bold">{resources?.HomeEventSelectionTitle}</p>
                            </div>

                            <div className="mb-3">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="eventSelection"
                                        id="sommerfest1"
                                        value={ticketTypeIdSommerfest1}
                                        checked={selectedTicketTypeId == ticketTypeIdSommerfest1}
                                        onChange={onEventSelect}
                                    />
                                    <label className="form-check-label" htmlFor="sommerfest1">
                                        {resources?.HomeSommerfest1Label}
                                    </label>
                                </div>
                            </div>

                            <div className="mb-4">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="eventSelection"
                                        id="sommerfest2"
                                        value={ticketTypeIdSommerfest2}
                                        checked={selectedTicketTypeId == ticketTypeIdSommerfest2}
                                        onChange={onEventSelect}
                                    />
                                    <label className="form-check-label" htmlFor="sommerfest2">
                                        {resources?.HomeSommerfest2Label}
                                    </label>
                                </div>
                            </div>

                            <div className="mb-4">
                                <p>{resources?.HomeEventNote}</p>
                            </div>

                            <div className="row mt-5">
                                <div className="col-12 text-end">
                                    <button
                                        className="btn-register button"
                                        onClick={onSubmit}
                                        disabled={!selectedTicketTypeId}
                                    >
                                        Weiter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer language="de" />
                </>
            )}
        </div>
    )
}

export default Home